export const iconFontAwesomeTravelHotelAccessibleIcon = (
	<i className="fa-solid fa-accessible-icon"></i>
);
